let formatDate = (value, type) => {
  if (!value) {
    return
  }
  let date = new Date(value * 1000)
  let y: any = date.getFullYear()
  let MM: any = date.getMonth() + 1
  MM = MM < 10 ? ('0' + MM) : MM
  let d: any = date.getDate()
  d = d < 10 ? ('0' + d) : d
  let h: any = date.getHours()
  let next_h = h < 10 ? ('0' + (h + 1)) : (h + 1)
  h = h < 10 ? ('0' + h) : h
  let m: any = date.getMinutes()
  m = m < 10 ? ('0' + m) : m
  let s: any = date.getSeconds()
  s = s < 10 ? ('0' + s) : s
  if (type == 1) {
    return y + '-' + MM + '-' + d + ' ' + h + ':' + m + '-' + next_h + ':' + m
  } else if (type == 2) {
    return y + '-' + MM + '-' + d + ' ' + h + ':' + m
  } else if (type === 3) {
    return y + '/' + MM + '/' + d + ' ' + h + ':' + m
  } else if (type === 4) {
    return  h + ':' + m
  } else if (type === 5) {
    return y + '/' + MM + '/' + d
  }
}
/**获取本月、上月、下月的起始日、结束日 (不传或0代表本月，-1代表上月，1代表下月)*/
// 1.调用方法 getMonth("s",0)、getMonth("e",0)
// 2.type 为"s"代表开始日期,type为"e"代表结束日期
// 3.dates  不传或0代表本月，-1代表上月，1代表下月
export const getMonth = (type, months, year, month) => {
  // var d = new Date();
  // var year = d.getFullYear();
  // var month = d.getMonth() + 1;


  if (Math.abs(months) > 12) {
      months = months % 12
  };
  if (months != 0) {
      if (month + months > 12) {
          year++;
          month = (month + months) % 12;
      } else if (month + months < 1) {
          year--;
          month = 12 + month + months;
      } else {
          month = month + months;
      };
  }
  // month = month < 10 ? "0" + month: month;
  // var date = d.getDate()
  var firstday = year + "-" + month + "-" + "01";
  var lastday = ""
  if (month == "01" || month == "03" || month == "05" || month == "07" || month == "08" || month == "10" || month == "12") {
      lastday = year + "-" + month + "-" + 31;
  } else if (month == "02") {
      if ((year % 4 == 0 && year % 100 != 0) || (year % 100 == 0 && year % 400 == 0)) {
          lastday = year + "-" + month + "-" + 29;
      } else {
          lastday = year + "-" + month + "-" + 28;
      }
  } else {
      lastday = year + "-" + month + "-" + 30;
  }
  var day = ""
  if (type == "s") {
      day = firstday;
  } else {
      day = lastday;
  }
  return day;
}


let learnStatus = (type) => {
  let list = {
    1: 'learn_color_D8D8F7',
    2: 'learn_color_F9E3E3',
    3: 'learn_color_E0FBFB',
    0: 'learn_color_333333',
    4: 'learn_color_5-3',
    5: 'learn_color_3-1',
    6: 'learn_color_1',
  }
  return list[type]
}
let getCookie = (cname) => {
  var name = cname + '='
  var ca = document.cookie.split(';')
  for (var i = 0; i < ca.length; i++) {
    var c = ca[i]
    while (c.charAt(0) == ' ') c = c.substring(1)
    if (c.indexOf(name) != -1) {
      return c.substring(name.length, c.length)
    }
  }
  return '[]'
}

let mul = (arg1, arg2) => {
  var m = 0, s1 = arg1.toString(), s2 = arg2.toString();
  try {
    m += s1.split(".")[1].length;
  }
  catch (e) {
  }
  try {
    m += s2.split(".")[1].length;
  }
  catch (e) {
  }
  return Number(s1.replace(".", "")) * Number(s2.replace(".", "")) / Math.pow(10, m);
}
let setCookie = (cname, cvalue, exdays) => {
  var d = new Date()
  d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000))
  var expires = 'expires=' + d.toUTCString()
  document.cookie = cname + '=' + cvalue + '; ' + expires
}

export {
  formatDate,
  learnStatus,
  getCookie,
  setCookie,
  mul
}
